import toast from "react-hot-toast";
import * as api from "../Api";

export const createIndividualInvestment = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Submitting investment for approval...");
    const { data } = await api.createIndividualInvestment(postData);
    dispatch({ type: "CREATE_INDIVIDUAL_INVESTMENT", payload: data });
    toast.remove(creatingId);
    toast.success("Successfully submitted");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};
export const getAllIndividualInvestment = () => async (dispatch) => {
  try {
    const { data } = await api.getIndividualInvestments();
    dispatch({ type: "GET_ALL_INDIVIDUAL_INVESTMENTS", payload: data });
  } catch (error) {}
};

export const approveIndividualInvestment =
  (id, postData) => async (dispatch) => {
    let approvingId;
    try {
      approvingId = toast.loading("Saving changes...");
      await api.updateIndividualInvestment(id, postData);
      dispatch({ type: "APPROVE_INDIVIDUAL_INVESTMENT", payload: id });
      toast.remove(approvingId);
      toast.success("Changes saved successfully");
    } catch (error) {
      toast.remove(approvingId);
      toast.error(error.message);
    }
  };

export const deleteIndividualInvestment = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting Investment...");
    await api.deleteIndividualInvestment(id);
    dispatch({ type: "DELETE_INDIVIDUAL_INVESTMENT", payload: id });
    toast.remove(deletingId);
    toast.success("Investment Successfully deleted");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};
